import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';

export default class ShowOnOpenModal extends Component {
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.addListener(Notifications.TOGGLE_MODAL, this.handleToggleModal);
  }

  handleToggleModal({ id }: { id: string }): void {
    if (!id || id !== this.el.dataset.modalId) return;

    this.el.classList.remove('hidden');
  }
}
